import React, { useContext } from 'react';
import { Grid, AppBar, Tab, Tabs, TextField, MenuItem } from '@mui/material';
import { customerTicketDetailsContext } from './CustomerTicketDetailsContext';
import { PageHeader } from 'components';
import { BaseInfo, Messages, LinkedOrders } from './components';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { appUserContext } from 'helpers/services';


let TicketDetails = () => {
    let { formatMessage } = useIntl();

    let { isMobile } = useContext(appUserContext);

    let service = useContext(customerTicketDetailsContext);

    let [tab, setTab] = React.useState<string>(LocalizationIds.Messages);


    return (
        <div>
            {service.isLoading === false &&
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            pageTitle={service.ticket.title}
                            subTitle={`${service.ticket.ticketNumber} - ${service.ticket.customerName}`}
                        />
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} md={4}>
                            <BaseInfo />
                        </Grid>
                        <Grid item xs>
                            {isMobile === false &&
                                <AppBar position="static" color="secondary">
                                    <Tabs
                                        indicatorColor="secondary"
                                        textColor="inherit"
                                        variant="scrollable"
                                        value={tab}
                                        onChange={(e, newValue) => setTab(newValue)}
                                    >
                                        <Tab label={formatMessage({ id: LocalizationIds.Messages })} value={LocalizationIds.Messages} />
                                        <Tab label={formatMessage({ id: LocalizationIds.LinkedOrders })} value={LocalizationIds.LinkedOrders} />
                                    </Tabs>
                                </AppBar>
                            }
                            {isMobile === true &&
                                <Grid container>
                                    <Grid item xs={12}>
                                        <TextField
                                            select
                                            name="tab"
                                            value={tab}
                                            onChange={(e: any) => {
                                                setTab(e.target.value);
                                            }}
                                            variant="standard"
                                        >
                                            <MenuItem value={LocalizationIds.Messages}>
                                                {formatMessage({ id: LocalizationIds.Messages })}
                                            </MenuItem>
                                            <MenuItem value={LocalizationIds.LinkedOrders}>
                                                {formatMessage({ id: LocalizationIds.LinkedOrders })}
                                            </MenuItem>
                                        </TextField>
                                    </Grid>
                                </Grid>
                            }

                            <div role="tabpanel" hidden={tab !== LocalizationIds.Messages}>
                                {tab === LocalizationIds.Messages && <Messages />}
                            </div>
                            <div role="tabpanel" hidden={tab !== LocalizationIds.LinkedOrders}>
                                {tab === LocalizationIds.LinkedOrders && <LinkedOrders />}
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            }
        </div>
    )
}

export default TicketDetails;